export default {
	0: "once",
	1: "daily",
	2: "monthly",
	3: "quarterly",
	4: "yearly"
};
